import { createAsyncThunk } from "@reduxjs/toolkit";
import { setRequestsList } from "states/pendingRequests/pendingRequestsSlice";
import { setCollaborationOffers, setSingleCollaborationData } from "states/singleCollaboration/singleCollaborationSlice";

import { fetchAllCollaborations, fetchMyPendingCollaborations, fetchSingleCollaborationData } from "api/collaborationsApi";


// Fetch all collaborations (async thunk)
export const getAllCollaborationsCall = createAsyncThunk(
    "getAllCollaborations/getAllCollaborationsData",
    async ({ token, data, page, dropdownOpen }, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchAllCollaborations(token, data, page); // Get the collaborations data

            // Optionally open dropdown after the data is fetched
            dropdownOpen();
            return response; // Returning the response (or necessary data)
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return backend error if present
            } else {
                return rejectWithValue(error.message || "An unknown error occurred");
            }
        }
    }
);

// Fetch pending collaborations (async thunk)
export const getMyPendingCollaborationsCall = createAsyncThunk(
    "myPendingCollaborations/getMyPendingCollaborations",
    async ({ token, data, page, user }, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchMyPendingCollaborations(token, data, page); // Call the API
            console.log("pending collab req", response?.data);

            // Dispatch the collaboration data to the Redux store
            await dispatch(setRequestsList(response?.data?.collaborations?.data));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return error from backend if available
            } else {
                return rejectWithValue(error); // Return error
            }
        }
    }
);

// Fetch single collaboration data (async thunk)
export const getSingleCollaborationDataCall = createAsyncThunk(
    "collaborationDetails/getCollaborationDetails",
    async ({ token, data }, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchSingleCollaborationData(token, data); // Call the API

            // Dispatch the collaboration data and offers to the Redux store
            dispatch(setCollaborationOffers(response?.data?.offers));
            dispatch(setSingleCollaborationData(response?.data));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); // Return error from backend if available
            } else {
                return rejectWithValue(error); // Return error
            }
        }
    }
);